export async function getGravatarUrl(email: string, size = 96): Promise<string> {
  const trimmed = email.trim().toLowerCase();
  const hashBuffer = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(trimmed),
  );
  const hashHex = Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return `https://gravatar.com/avatar/${hashHex}?s=${size}&d=mp`;
}
